import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Layout components
import AdminLayout from "./layouts/AdminLayout";
import AuthLayout from "./layouts/AuthLayout";

// Auth pages
import Login from "./pages/auth/Login";

// Admin pages
import GiveawaysList from "./pages/admin/GiveawaysList";
import MembersList from "./pages/admin/MembersList";

// Public pages
import ClaimGiveaway from "./pages/ClaimGiveaway";

// Auth actions
import { checkAuth } from "./features/auth/authSlice";

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, user, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  // Protected route component for admin routes
  const AdminRoute = ({ children }) => {
    console.log("user user:", user);
    if (loading) return <div>Loading...</div>;
    if (!isAuthenticated) return <Navigate to="/login" />;
    return children;
  };

  // Redirect authenticated users away from auth pages
  const AuthRoute = ({ children }) => {
    console.log("user user 1:", user);
    if (loading) return <div>Loading...</div>;
    if (isAuthenticated) {
      return <Navigate to="/admin/members" />;
    }
    return children;
  };

  return (
    <>
      <Routes>
        {/* Auth Routes */}
        <Route path="/" element={<AuthLayout />}>
          <Route index element={<Navigate to="/login" />} />
          <Route
            path="login"
            element={
              <AuthRoute>
                <Login />
              </AuthRoute>
            }
          />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/members" />} />
          <Route
            path="members"
            element={
              <AdminRoute>
                <MembersList />
              </AdminRoute>
            }
          />
          <Route
            path="giveaways"
            element={
              <AdminRoute>
                <GiveawaysList />
              </AdminRoute>
            }
          />
        </Route>

        {/* Public Routes */}
        <Route path="/claim-giveaway/:id" element={<ClaimGiveaway />} />
        
        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      <ToastContainer position="bottom-right" />
    </>
  );
}

export default App;
